<template>
  <v-card outlined>
    <v-container class="px-4 py-1" fluid>
      <v-card flat>
        <v-card-title class="py-1">
          {{ $t('ELE0028') }}
        </v-card-title>
        <v-row dense class="mb-1">
          <v-col cols="4">
            <TextFieldRef v-if="isActioned" :label="$t('ELE0052')" :value="searchCondition.mmmmNo" />
            <TextFieldInput v-else :label="$t('ELE0052')" v-model="searchCondition.mmmmNo" />
          </v-col>
          <v-spacer />
          <v-col cols="8" v-if="!isModal">
            <span d-flex flex-row space-between>
              <BtnSearch class="ml-4" @click="onClickSearch" :disabled="isActioned || searchCondition.mmmmNo == ''" />
              <BtnNew class="mx-4" @click="onClickNew" :disabled="isActioned || searchCondition.mmmmNo != ''" />
              <BtnReset class="mx-4" @click="onClickResetForm" :disabled="!isActioned" />
            </span>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <v-container v-if="form != null" fluid>
      <v-card outlined>
        <v-row v-if="form.statusCd != ''" class="px-4 py-2">
          <v-col cols="2">
            <TextFieldRef :label="$t('ELE0217')" :value="getEnumlang('MmmmApprovalStatusCd.', form.statusCd)" />
          </v-col>
          <v-col cols="2">
            <TextFieldRef :label="$t('ELE0440')" :value="getEnumlang('MmmmDispositionCd.', form.dispositionCd)" />
          </v-col>
          <v-col cols="4">
            <TextFieldRef :label="$t('ELE0543')" :value="form.wfRemarks" />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <MmmmRequestSupplierForm
              :form="form"
              :canEditEpson="canEditEpson"
              @reset="onClickResetForm"
              @research="search"
            />
          </v-col>
        </v-row>
        <v-row v-if="isProcessedEpsonRoute" dense>
          <v-col>
            <MmmmRequestEpsonForm
              :form="form"
              :canEditEpson.sync="canEditEpson"
              @reset="onClickResetForm"
              @research="search"
            />
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </v-card>
</template>

<script>
import { MmmmWfCheckedCat, MmmmApprovalStatusCd } from '@/enum'
import dayjs from 'dayjs'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'

import BtnSearch from '@/components/atoms/button/BtnSearch'
import BtnNew from '@/components/atoms/button/BtnNew'
import BtnReset from '@/components/atoms/button/BtnReset'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'

import MmmmRequestSupplierForm from '@/components/organisms/terminal/form/MmmmRequestSupplierForm'
import MmmmRequestEpsonForm from '@/components/organisms/terminal/form/MmmmRequestEpsonForm'

export default {
  name: 'MmmmRequestForm',

  mixins: [APIUtils, Message, Loading, DateUtils],

  components: {
    BtnSearch,
    BtnNew,
    BtnReset,
    TextFieldInput,
    TextFieldRef,
    MmmmRequestSupplierForm,
    MmmmRequestEpsonForm,
  },

  props: {
    propsMmmmNo: {
      type: String,
      required: false,
      default: '',
    },
    isModal: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      searchCondition: {
        mmmmNo: '',
      },
      form: null,
      isActioned: false,
      canEditEpson: false,
    }
  },

  computed: {
    isProcessedEpsonRoute: {
      // EPSONルートで処理したか判定
      get() {
        let result = false
        if (this.form.epsonRoutes) {
          if (
            this.form.statusCd == MmmmApprovalStatusCd.SUPPLIER_APPROVED ||
            (this.form.epsonRoutes.length > 0 &&
              this.form.epsonRoutes.some((e) => e.checkers.some((checker) => checker.result !== null)))
          ) {
            result = true
          }
        }
        return result
      },
    },
  },

  methods: {
    getEnumlang(key, value) {
      // langのenumからメッセージ取得
      let lang = ''
      if (value) {
        lang = this.$t(key + value)
      }
      return lang
    },

    async search(mmmmNo) {
      this.searchCondition.mmmmNo = mmmmNo
      await this.onClickSearch()
    },

    async onClickSearch() {
      try {
        this.startLoading()
        this.form = null
        this.isActioned = false

        const params = {
          mmmmNo: this.searchCondition.mmmmNo,
          userCompanyCd: this.$store.getters.companyCd,
        }

        this.form = await API.get('/mmmm/info', params)
        this.isActioned = true
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0052') })))
      } finally {
        this.stopLoading()
      }
    },

    onClickNew() {
      this.form = {
        mmmmNo: '',
        wfNo: null,
        wfVersionNo: null,
        statusCd: '',
        currentRouteName: '',
        partGroupCd: '',
        applCatCd: '',
        applRequestByCd: '',
        sectionCd: '',
        reasonCd: '',
        reasonDtlCd: '',
        remarks: '',
        severityCd: '',
        severityName: '',
        manufacturerCd: '',
        issueDate: dayjs().format('YYYY-MM-DD'),
        targetUsageDate: null,
        tenNo: '',
        ptCd: '',
        moldNo: '',
        partCd: '',
        partName: '',
        partCatCd: '',
        model: '',
        lotNo: '',
        drawingNo: '',
        reqSampleAttached: false,
        sampleAttachedQty: null,
        oqcInspIndexNo: '',
        plPr: {
          numOfCav: '',
          cavNo: '',
          cycleTime: '',
          mcNo: '',
          mcBrand: '',
          tonnage: '',
          productTakeOutCd: '',
          matlSupplier: '',
          matlGrade: '',
          color: '',
          injectionMcTypeCd: '',
          partsWeight: '',
          sprueWeight: '',
          scrapWeight: '',
          moldAssetNo: '',
          mcsRegistrationNo: '',
          mcsRegistrationFilePath: '',
        },
        paint: {
          paintColor: '',
          paintCode: '',
          paintSpecification: '',
          paintSupplier: '',
          paintProcessCd: '',
        },
        secondProcess: {
          secondCatCds: [],
          othersDetail: '',
          parts: [],
        },
        print: {
          inkColor: '',
          inkCode: '',
          inkSpecification: '',
          inkSupplier: '',
          printProcessCd: '',
          remarks: '',
        },
        requiredDocs: [],
        requestCompanyCd: this.$store.getters.companyCd,
        requestCompanyCatCd: this.$store.getters.companyCatCd,
        requesterCd: this.$store.getters.userCd,
        acceptCompanyCd: '',
        accepterCd: '',
        currentRouteNo: 1,
        currentRouteDtlNo: 1,
        supplierRoute: {
          routeNo: 1,
          checkers: [
            {
              routeDtlNo: 1,
              checkerCd: this.$store.getters.userCd,
              checkedDatetime: '',
              remarks: '',
              checkedCat: MmmmWfCheckedCat.REQUEST,
            },
            {
              routeDtlNo: 2,
              checkerCd: '',
              checkedDatetime: '',
              remarks: '',
              checkedCat: MmmmWfCheckedCat.CHECK,
            },
            {
              routeDtlNo: 3,
              checkerCd: '',
              checkedDatetime: '',
              remarks: '',
              checkedCat: MmmmWfCheckedCat.APPROVE,
            },
          ],
        },
      }
      this.isActioned = true
    },

    onClickResetForm() {
      if (this.propsMmmmNo) {
        this.$emit('close')
      }
      Object.assign(this.$data, this.$options.data.call(this))
    },
  },

  mounted() {
    if (this.propsMmmmNo) {
      this.search(this.propsMmmmNo)
    }
  },
}
</script>
